import fs from "fs";
import { careerHistory } from "./careers";
import { templateLoopParser } from "../../../parser";

const template = fs.readFileSync(__dirname + "/index.html", "utf8");

export const Career = () => {
  return `<ul>${templateLoopParser(careerHistory, template)}</ul>`;
};
